import React, { useEffect, useState } from 'react';
import { NewsClient } from '../../client/news-client';
import { NewsIconSvg } from './news-icon-svg';
import './index.scss';

type NewsIconProps = {
  employeeId: string;
  renderSmallSvg?: boolean;
  stage: string;
};

export function NewsIcon(props: NewsIconProps) {
  const [unreadNewsCount, setNewsCount] = useState<number>(0);

  useEffect(() => {
    if (!props.employeeId) return;

    NewsClient.getUnreadNews(props.employeeId, props.stage)
      .then(count => {
        if (count !== 0) {
          setNewsCount(count);
        }
      })
      .catch(() => {
        // We don't want to interrupt the UI, just don't show the badge
        console.error('Failed to retrieve unread news');
      });
  }, [props.employeeId, props.stage]);

  const renderBadge = () => {
    if (unreadNewsCount === undefined || unreadNewsCount < 1) return;

    return (
      <div className="atoz-news-badge">
        <div className="atoz-news-number"> </div>
      </div>
    );
  };

  // The smaller SVG is used by the AtoZShiftManagementApp, while the sprite is used by the AtoZDashboardApp
  if (props.renderSmallSvg) {
    return (
      <div className="atoz-news-sm-svg-icon">
        <NewsIconSvg />
        {renderBadge()}
      </div>
    );
  } else {
    return (
      <div className="atoz-news-icon">
        <div className="news-icon-btn sc-sprite sc-news-button" />
        {renderBadge()}
      </div>
    );
  }
}
